import { createAsyncThunk } from '@reduxjs/toolkit';

import { store } from '@/Infrastructure/State';
import type { Address } from '@/modules/address/domain/Address';
import type { AddressRepository } from '@/modules/address/domain/AddressRepository';
import { addressSessionStorageRepository } from '@/modules/address/infrastructure/AddressSessionStorageRepository';

const SAVE_ADDRESS = 'address/saveAddress';
const FETCH_ADDRESS = 'address/fetchAddresses';
const SET_SELECTED_ADDRESS = 'address/setSelectedAddress';

export const saveAddress = createAsyncThunk(
  SAVE_ADDRESS,
  async (addressPayload: Address | Omit<Address, 'id'>) => {
    const address = await addressSessionStorageRepository.save(addressPayload);

    return address;
  }
);

export const fetchAddresses = createAsyncThunk(FETCH_ADDRESS, async () => {
  const addresses = await addressSessionStorageRepository.getAll();
  return addresses;
});

export const setDefaultAddress = createAsyncThunk(
  SET_SELECTED_ADDRESS,
  async (addressId: Address['id']) => {
    const address =
      await addressSessionStorageRepository.setDefaultAddress(addressId);
    return address;
  }
);

const AddressReduxRepository: AddressRepository = {
  getAll: async () => {
    const { payload } = await store.dispatch(fetchAddresses());
    return payload as Address[];
  },
  save: async (addressPayload) => {
    const { payload } = await store.dispatch(saveAddress(addressPayload));
    return payload as Address;
  },
  setDefaultAddress: async (addressId) => {
    const { payload } = await store.dispatch(setDefaultAddress(addressId));
    return payload as Address;
  }
};

export default AddressReduxRepository;
